<template>
<div>

<ContentHeader v-if="data"  :title="projectname"  :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don" url="SupplierBrandProjects" ></ContentHeader>




<div class="content_card" >
<div class="grid">
<div class="col-12">
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<div class="content_card_content" v-if="!loading">

<div class="grid">
<div class="col-3 md:col-2"><p class="click_edit_value_title" >{{$store.state.languages.lang_phrases.donem}}:</p></div>
<div class="col-9 md:col-10 mt-0" ><p class="click_edit_value" >{{data.projectperiod.name}}</p></div>
</div>
<h4 class="text-primary">{{$store.state.languages.lang_phrases.proje_akislari}}</h4>
<div class="grid">


<CollapsableFlowCard viewer="supplier" v-for="item in flowsuppliers" :flowsupplier="item" :activeflow="data.activeflow"></CollapsableFlowCard>



</div>


</div>



</div>
</div>

</div>
</div>
</template>

<script>
export default {

  name: 'SupplierBrandProject',
  data () {
    return {
    	loading:true,
    	data:null,
      flowsuppliers:[]
    }
  },
  sockets: {
    project_supplier_data_updated(data) {
      console.log("%c evaluation_supplier_data_updated ","color:white;background-color:#352f8d;font-weight:light;")
      console.log(data)
    },
  },
  computed:{
    projectname()
    {
      if(this.data.project.translations.length)
      {
        let translation = this.data.project.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        if(translation)
        {
          return translation.translation
        }
        else
        {
          return this.data.project.name
        }
      }
      else
      {
        return this.data.project.name
      }
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"projeler") 
    this.$socket.emit('supplier_viewing_project_details_page', { projectsupplier_uuid: this.$route.params.project_id })
    this.$store.dispatch('evaluation/setActiveProjectSupplier',this.$route.params.project_id)
  	this.getData()
  },
  methods:{
  	async getData()
  	{
      this.loading = await true
  	 let data = await this.silentApiGet("audit/project_supplier/"+this.$route.params.project_id) 
      for(let item of data.flow_suppliers)
      {
        item.project_supplier = await data.project_supplier
      }
      this.data = await data.project_supplier
      this.flowsuppliers = await data.flow_suppliers
      this.loading = await false
      console.log(data);
  	},

  },
}
</script>

<style lang="css" scoped>
</style>